import { ButtonHTMLAttributes, DetailedHTMLProps, useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  title: string;
  active: boolean;
}

export default function FilterTabItem({ title, active, ...props }: Props) {
  const { darkTheme } = useTheme();

  const classes = useMemo(
    () =>
      darkTheme
        ? `${
            active
              ? `text-white bg-[#FFFFFF33] hover:bg-[#FFFFFF29] disabled:hover:bg-[#FFFFFF33]`
              : 'text-[#FFFFFFB8] hover:text-white disabled:hover:text-[#FFFFFFB8]'
          }`
        : `${
            active
              ? `text-white bg-blue hover:bg-black disabled:hover:bg-blue`
              : 'text-gray hover:text-black hover:bg-[#1B42E30A] disabled:hover:text-gray disabled:hover:bg-[#FFFFFF33]'
          }`,
    [darkTheme, active]
  );

  return (
    <button
      type="button"
      {...props}
      className={`flex items-center justify-center rounded-lg px-2 py-1.5 text-[16px] font-light leading-[20px] transition-all duration-300 ease-out ${classes}`}
    >
      <span>{title}</span>
    </button>
  );
}
